import React, {Component} from 'react';
import {connect} from 'react-redux'
import {
    Field,
    reduxForm,
    change as changeForm,
} from 'redux-form'
import {locale} from '../../locale/AppLocale'
import Loader from "../../Components/Loader";
import axios from 'axios';
import {NotificationManager} from '../../Helpers/NotificationManager';;
import isEmpty from 'validator/lib/isEmpty';
import isInt from 'validator/lib/isInt';
import trim from 'validator/lib/trim';
import ProductInput from "../../Components/ProductInput";
import Config from "../../Helpers/Config";
import ShooqModal from '../../Components/ShooqModal';
import NotFound from '../NotFound';

const IBAN = require('iban');

let _banksList = [];

class BankAccount extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
            ready: false,
            failed: false,
            submittingForm: false,
            banksList: [],
            openModal: false,
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.init = this.init.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.createMarkup = this.createMarkup.bind(this);
    }

    toggleModal() {
        this.setState({
            openModal: !this.state.openModal
        });
    }

    componentDidMount() {
        this.init();
    }

    init() {
        this.setState({
            fetching: true
        }, () => {
            const data = {};
            axios.post(`${Config.api()}financial/bank/init/${this.props.auth.business.id}`, data, {
                withCredentials: Config.withCredentials()
            }).then((response) => {
                if (response.data.status) {
                    _banksList = response.data.banks;

                    Object.keys(response.data.business).forEach((fieldName, index) => {
                        let value = response.data.business[fieldName];
                        this.props.dispatch(changeForm('BankAccount', fieldName, response.data.business[fieldName].toString()));
                    });

                    this.setState({
                        fetching: false,
                        ready: true,
                        banksList: response.data.banks,
                    });
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                    this.setState({
                        fetching: false,
                        ready: true,
                        failed: true,
                        banksList: response.data.banks,
                    });
                }
            }).catch((error) => {
                console.log(error, error.response)
                if (typeof error.response.status !== 'undefined' && error.response.status === 401) {
                    this.props.requiresReLogin();
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                    this.setState({
                        fetching: false,
                        ready: true,
                        failed: true,
                        banksList: [],
                    });
                }
            });
        });
    }

    onSubmit(values) {
        console.log('values',values)
        const errors = validateBankAccount(values, this.props);
        if (Object.keys(errors).length > 0) {
            NotificationManager.error(locale.get('please_fill_all_required_fields'));
            return false;
        }
        this.setState({
            submittingForm: true
        }, () => {

            axios.post(`${Config.api()}financial/bank/save/${this.props.auth.business.id}`, values, {
                withCredentials: Config.withCredentials()
            }).then((response) => {
                this.setState({
                    submittingForm: false,
                });

                if (response.data.status === true) {
                    NotificationManager.success(locale.get('your_bank_details_saved_successfully'));
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_saving_your_bank_details'));
                }
            }).catch((error) => {
                this.setState({
                    submittingForm: false,
                });
                if (error.response.status === 401) {
                    this.props.requiresReLogin();
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_saving_your_bank_details'));
                }
            });
        });

    }

    createMarkup(string) {
        return {__html: string};
    }

    render() {
        return (

            this.state.fetching && !this.state.ready ? <Loader completed={this.state.ready}/> : this.state.failed ?
                <div>
                    <div className="not-found">
                        {locale.get('an_error_occurred_while_initializing_data')}
                    </div>

                </div> : <div>
                    {
                        this.state.openModal &&
                        <ShooqModal showModal={this.state.openModal} onRequestClose={this.toggleModal}
                                     modalTitle={locale.get('what_is_iban')}>
                            <div dangerouslySetInnerHTML={this.createMarkup(locale.get('what_is_iban_description'))}/>
                        </ShooqModal>

                    }
                    <form className="form-horizontal" onSubmit={this.props.handleSubmit(this.onSubmit) }>
                        <div className="panel-1">
                            <div className="panel-1--head bg-white">
                                {locale.get('my_bank_details')}
                            </div>
                            <div className="panel-1--body is-full">
                                <Field
                                    type="text"
                                    name="bank_benf_name"
                                    id="bank_benf_name"
                                    disabled={false}
                                    component={ProductInput}
                                    className="form-control"
                                    label={locale.get('beneficiary_name')}
                                    placeholder={locale.get('beneficiary_name')}
                                    field={{is_required: true}}
                                    required="required"/>
                                <Field
                                    name="bank_id"
                                    id="bank_id"
                                    component={ProductInput}
                                    className="form-control"
                                    label={locale.get('bank_name')}
                                    placeholder={locale.get('bank_name')}
                                    field={{is_required: true, data_type: "dropdown", options: this.state.banksList}}/>

                                <Field
                                    type="text"
                                    name="bank_account_number"
                                    id="bank_account_number"
                                    disabled={false}
                                    component={ProductInput}
                                    className="form-control"
                                    label={locale.get('bank_account_number')}
                                    placeholder={locale.get('bank_account_number')}
                                    field={{is_required: true}}
                                    required="required"/>
                                <Field
                                    type="text"
                                    name="bank_branch"
                                    id="bank_branch"
                                    disabled={false}
                                    component={ProductInput}
                                    className="form-control"
                                    label={locale.get('bank_branch')}

                                    placeholder={locale.get('bank_branch')}
                                    field={{is_required: true}}
                                    required="required"/>

                                <Field
                                    type="text"
                                    name="bank_iban"
                                    id="bank_iban"
                                    disabled={false}
                                    component={ProductInput}
                                    className="form-control"
                                    label={locale.get('bank_iban')}
                                    placeholder={locale.get('bank_iban')}
                                    alt_label={<button className="btn btn-3 btn--small mt-10 pull-inverse"
                                                       type="button" onClick={() => {
                                        this.toggleModal()
                                    }}>{locale.get('what_is_iban')}</button>
                                    }
                                    field={{is_required: true}}
                                    required="required"/>

                            </div>
                            <div className="clearfix"/>
                            <div className="panel-1--footer">
                                <button className="btn-1" disabled={this.state.submittingForm}><Loader
                                    completed={this.state.submittingForm === false}/> {locale.get('save_details')}
                                </button>
                            </div>

                        </div>
                    </form>


                </div>

        )
    }
}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({});
const validateBankAccount = (values, props) => {
    let errors = {};
    if (!values.bank_benf_name || isEmpty(trim(values.bank_benf_name))) {
        errors.bank_benf_name = locale.get('required');
    }
    if (values.bank_id && values.bank_id.value){
        values.bank_id = values.bank_id.value;
    }
    if (!values.bank_id || isEmpty(trim(values.bank_id.toString()))) {
        errors.bank_id = locale.get('required');
    } else {
        let index = _banksList.findIndex(function (bank) {
            return bank.id === values.bank_id;
        });
        if (index === -1 || _banksList[index].id !== values.bank_id) {
            errors.bank_id = locale.get('please_select_valid_bank');
        }
    }

    if (!values.bank_account_number || isEmpty(trim(values.bank_account_number.toString()))) {
        errors.bank_account_number = locale.get('required');
    }
    if (!values.bank_branch || isEmpty(trim(values.bank_branch))) {
        errors.bank_branch = locale.get('required');
    }
    if (!values.bank_iban || isEmpty(trim(values.bank_iban))) {
        errors.bank_iban = locale.get('required');
    } else if (!IBAN.isValid(trim(values.bank_iban))) {
        errors.bank_iban = locale.get('iban_is_invalid');
    }
    errors = {...errors}
    return errors;
};


BankAccount = reduxForm({
    form: 'BankAccount',
    enableReinitialize: true,
    validate: validateBankAccount,
})(BankAccount);

export default connect(mapStateToProps, mapDispatchToProps)(BankAccount);
